
import React, {Component, useEffect, useState } from "react";
import Moment from 'react-moment';
import moment from 'moment';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
//import DateTimePicker from '@mui/lab/DateTimePicker';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import MobileDateTimePicker from '@mui/lab/MobileDateTimePicker'
import TextField from '@mui/material/TextField';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import generatePDFParking from "../services/reportGeneratorParking";
import BeatLoader from "react-spinners/BeatLoader";
import authHeader from "../services/auth-header";

import { BarChart, Bar, LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip } from 'recharts';
//import { Link } from 'react-router-dom';
import { useParams } from "react-router-dom";
//import DetectorsByParking from '../detectors/DetectorsByParking';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { useTranslation } from "react-i18next";

import ReactDOM from "react-dom";

import useWindowDimensions from "../components/charts/windowDimensions";

const api = require("../api/names.js");

function ParkingStats(props) {

  const { t } = useTranslation("common");

    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [items, setItems] = useState([]);
    const [parkingName, setParkingName] = useState([]);
    const [itemsStateChanged, setItemsStateChanged] = useState([]);
    const [generating, setGenerating] = useState(0);
    //const [itemsParkingStatsOccupancy, setItemsParkingStatsOccupancy] = useState([]);
    const [dateMin, setDateMin] = useState(new Date(Date.now() - (1*24*60*60*1000)));
    const [dateMax, setDateMax] = useState(new Date());

    const params = useParams();
    console.log(params);

    const { height, width } = useWindowDimensions();

    useEffect(() => {

      var url = api.baseUrl + '/parkings/';
      url += params.parkingID;
      //console.log(url);
      fetch(url, {
    method: 'get',
    headers: authHeader()
    })
        .then(res => res.json())
        .then(
          (result) => {
            //console.log(result);
            setIsLoaded(true);
            setParkingName(result);

          },
          (error) => {
            setIsLoaded(true);
            setError(error);
          }
        )

        url = api.baseUrl+'/detectorsHistoryValues/byParkingID/';
        //var url = api.baseUrl+'/detectorsCurrentValues/WithMetadataByAddress/';
        url += params.parkingID;
        url += "/";
        url += dateMin.getTime();
        url += "/";
        url += dateMax.getTime();
        //console.log(url);
        fetch(url, {
     method: 'get',
     headers: authHeader()
   })
        .then(res => res.json())
        .then(
          (result) => {
            setIsLoaded(true);
            setItemsStateChanged(result.filter(item => item.stateChange === 1));
          },
          (error) => {
            setIsLoaded(true);
            setError(error);
          }
        )



        url = api.baseUrl+'/parkingsHoursStats/byParkingID/';

        url += params.parkingID;
        url += "/";
        url += dateMin.getTime();
        url += "/";
        url += dateMax.getTime();
        console.log(url);
        fetch(url, {
     method: 'get',
     headers: authHeader()
   })
        .then(res => res.json())
        .then(
          (result) => {

            setIsLoaded(true);
            for(var i = 0; i < result.length; i++)
            {
              result[i].date = moment.unix(result[i].timestamp/1000).format("HH:mm:ss - DD/MM/YYYY");
            }
            setItems(result);
            console.log(items);
          },
          (error) => {
            setIsLoaded(true);
            setError(error);
          }
        )




    },[])

function LoadHistoryData() {
  var url = api.baseUrl+'/detectorsHistoryValues/byParkingID/';
  //var url = api.baseUrl+'/detectorsCurrentValues/WithMetadataByAddress/';
  url += params.parkingID;
  url += "/";
  url += dateMin.getTime();
  url += "/";
  url += dateMax.getTime();
  //console.log(url);
  fetch(url, {
method: 'get',
headers: authHeader()
})
  .then(res => res.json())
  .then(
    (result) => {
      setIsLoaded(true);
      setItemsStateChanged(result.filter(item => item.stateChange === 1));
    },
    (error) => {
      setIsLoaded(true);
      setError(error);
    }
  )

  url = api.baseUrl+'/parkingsHoursStats/byParkingID/';

  url += params.parkingID;
  url += "/";
  url += dateMin.getTime();
  url += "/";
  url += dateMax.getTime();
  console.log(url);
  fetch(url, {
method: 'get',
headers: authHeader()
})
  .then(res => res.json())
  .then(
    (result) => {

      setIsLoaded(true);
      result.date = moment(result).format("HH:mm:ss - DD/MM/YYYY");
      setItems(result);
      console.log(items);
    },
    (error) => {
      setIsLoaded(true);
      setError(error);
    }
  )
}

function changeGenerating() {

    setGenerating(1);
    setTimeout(() => {
      setGenerating(0);
    }, 2000);
  };

function seconds2time (seconds) {
        var hours   = Math.floor(seconds / 3600);
        var minutes = Math.floor((seconds - (hours * 3600)) / 60);
        seconds = seconds - (hours * 3600) - (minutes * 60);
        var time = "";

        if (hours !== 0) {
          time = hours+"h ";
        }
        if (minutes !== 0 || time !== "") {
          minutes = (minutes < 10 && time !== "") ? "0"+minutes : String(minutes);
          time += minutes+"min ";
        }
        if (time === "") {
          time = seconds+"s";
        }
        else {
          time += (seconds < 10) ? "0"+seconds : String(seconds)+"s";
        }
        return time;
    }

function loadStatistics() {

      var unique = [];
      var distinct = [];
      //alert(itemsStateChanged.length);
      for( let i = 0; i < itemsStateChanged.length; i++ ){
        if(   !unique[itemsStateChanged[i].address]){
              distinct.push(itemsStateChanged[i].address);
              unique[itemsStateChanged[i].address] = 1;
            }
          }
      var i=0;
      var arrayWolne = {};
      var arrayZajete = {};
      var arrayWjazdy = {};
      var arrayZjazdy = {};
      var stats = {};
      var detectorsDurations = [];
      var detectorsDurationsHours = [];
      var detectorsActions = [];
      var idDetectorDuration = 0;
      var idDetectorAction = 0;
      stats.detectorsActions = detectorsActions;
      stats.detectorsDurations = detectorsDurations;
      stats.detectorsDurationsHours = detectorsDurationsHours;
      for(i=0;i<itemsStateChanged.length;i++)
      {
        var address = itemsStateChanged[i].address;
        if(itemsStateChanged[i].isBusy === 1)
        {
          var detectorsAction = {
            "id": idDetectorAction+1,
            "address": address,
            "timestamp": itemsStateChanged[i].timestamp/1000,
            "type": "wjazd"
          }
          stats.detectorsActions.push(detectorsAction);
          idDetectorAction++;

        }
        else if(itemsStateChanged[i].isBusy === 0)
        {
          var detectorsAction = {
            "id": idDetectorAction+1,
            "address": address,
            "timestamp": itemsStateChanged[i].timestamp/1000,
            "type": "zjazd"
          }
          stats.detectorsActions.push(detectorsAction);
          idDetectorAction++;

        }
      }


      for( let j = 0; j < distinct.length; j++ ){
      var singleDetectorStats = {};
      singleDetectorStats = itemsStateChanged.filter(item => item.address === distinct[j]);

      for(i=1;i<singleDetectorStats.length;i++)
      {

        var duration = Math.round(singleDetectorStats[i].timestamp/1000 - singleDetectorStats[i-1].timestamp/1000);
        var address = singleDetectorStats[i].address;

        if(singleDetectorStats[i].isBusy === 1 && duration > 0)
        {
          var detectorDuration = {
            "id": idDetectorDuration+1,
            "address": address,
            "duration": duration,
            "start": singleDetectorStats[i-1].timestamp/1000,
            "stop": singleDetectorStats[i].timestamp/1000,
            "type": "wolny"
          }
          stats.detectorsDurations.push(detectorDuration);
          idDetectorDuration++;
        }
        else if(singleDetectorStats[i].isBusy === 0 && duration > 0){
          var detectorDuration = {
            "id": idDetectorDuration+1,
            "address": address,
            "duration": duration,
            "start": singleDetectorStats[i-1].timestamp/1000,
            "stop": singleDetectorStats[i].timestamp/1000,
            "type": "zajety"
          }
          stats.detectorsDurations.push(detectorDuration);
          idDetectorDuration++;
        }






      }

    }
      console.log(stats);
      arrayWolne = stats.detectorsDurations.filter(item => item.type === "wolny");
      arrayZajete = stats.detectorsDurations.filter(item => item.type === "zajety");
      arrayWjazdy = stats.detectorsActions.filter(item => item.type === "wjazd");
      arrayZjazdy = stats.detectorsActions.filter(item => item.type === "zjazd");
      var dataStart = dateMin.getTime()/1000;//moment("20220325").unix()+3600;
      var dataStop = dateMax.getTime()/1000;//moment().unix();


      //console.log(dataStart);
      //console.log(dateMin.getTime()/1000);

      var hourIterator = 0;
      for(let i=dataStart+3600;i<=dataStop;i+=3600)
      {
        var arrayZajeteHours = {};
        arrayZajeteHours = arrayWjazdy.filter(item => (item.timestamp >= i-3600 && item.timestamp < i));
        var arrayWolneHours = {};
        arrayWolneHours = arrayZjazdy.filter(item => (item.timestamp >= i-3600 && item.timestamp < i));
        var arrayZajeteHoursData = {
          "id": hourIterator+1,
          "entries": arrayZajeteHours.length,
          "exits": arrayWolneHours.length,
          "fromTimestamp": moment(new Date((i - 3600) * 1000)).format("HH:mm:ss - DD/MM/YYYY"),
          "toTimestamp": moment(new Date((i) * 1000)).format("HH:mm:ss - DD/MM/YYYY")
        }
        stats.detectorsDurationsHours.push(arrayZajeteHoursData);

        hourIterator++;
      }

      console.log(stats.detectorsDurationsHours);

      //console.log(arrayWolne);
      //console.log(arrayZajete);
      var maxZajete = Math.max.apply(Math, arrayZajete.map(function(o) { return o.duration; }));
      if(isFinite(maxZajete))
      {
      }
      else {
        maxZajete = 0;
      }
      var minZajete = Math.min.apply(Math, arrayZajete.map(function(o) { return o.duration; }));
      if(isFinite(minZajete))
      {
      }
      else {
        minZajete = 0;
      }
      if(minZajete < 0)
      {
        minZajete = 1;
      }
      //var sumZajete = Math.sum.apply(Math, arrayZajete.map(function(o) { return o.duration; }));

      //const sumZajete = arrayZajete => arrayZajete.reduce((a,b) => a + b, 0)
      //var avgZajete = sumZajete/(arrayZajete.length);
      var sumZajete = arrayZajete.reduce(function(_this, val) {
              return _this + val.duration
          }, 0);

      var sumWolne = arrayWolne.reduce(function(_this, val) {
                  return _this + val.duration
              }, 0);
      var percentageZajete = 0;
      var percentageWolne = 0;
      if((sumWolne+sumZajete) != 0)
      {
        //percentageZajete = ((sumZajete/(sumWolne+sumZajete))*100).toFixed(2);
        //percentageWolne = ((sumWolne/(sumWolne+sumZajete))*100).toFixed(2);

        percentageZajete = ((arrayWjazdy.length/(arrayWjazdy.length+arrayZjazdy.length))*100).toFixed(2);
        percentageWolne = ((arrayZjazdy.length/(arrayWjazdy.length+arrayZjazdy.length))*100).toFixed(2);
      }
      const avgZajete = Math.round((sumZajete / arrayZajete.length) || 0);

      var maxWolne = Math.max.apply(Math, arrayWolne.map(function(o) { return o.duration; }));
      if(isFinite(maxWolne))
      {
      }
      else {
        maxWolne = 0;
      }
      var minWolne = Math.min.apply(Math, arrayWolne.map(function(o) { return o.duration; }));
      if(isFinite(minWolne))
      {
      }
      else {
        minWolne = 0;
      }
      if(minWolne < 0)
      {
        minWolne = 1;
      }


var p_stats = {};
var parkingStats = []
p_stats.chart = 'div2PDF';
p_stats.id = 1;
p_stats.parkingId = params.parkingID;
p_stats.parkingName = parkingName.parkingName;
p_stats.description = parkingName.description;
p_stats.parkingStats = parkingStats;
console.log(p_stats);

var data = {
  "dateMin": dateMin,
  "dateMax": dateMax,
  "ilePojazdow": arrayZajete.length,
  "ileWjazdow": arrayWjazdy.length,
  "ileZjazdow": arrayZjazdy.length,
  "sredniCzasParkowania": seconds2time(avgZajete),
  "procentWolne": percentageWolne+'%',
  "procentZajete": percentageZajete+'%',
  "minWolne": seconds2time(minWolne),
  "maxWolne": seconds2time(maxWolne),
  "minZajete": seconds2time(minZajete),
  "maxZajete": seconds2time(maxZajete),
  "detectorDurations": stats.detectorsDurations,
  "entriesLeaves": stats.detectorsActions
}
p_stats.parkingStats.push(data);
console.log(p_stats);

/*var manager = "Jane Doe";
sitePersonel.employees[0].manager = manager;
console.log(sitePersonel);

console.log(JSON.stringify(sitePersonel));*/


      return(
        <div>
          <br/>
        <Button href='/parkings' variant="outlined" startIcon={<ArrowBackIcon />}>
            {t('parkingd.comeback')}
        </Button>

        <button
          className="btn btn-primary"
          onClick={() => { changeGenerating(); generatePDFParking(p_stats) }}
          disabled={generating}>
          <BeatLoader loading={generating} size={15} color='#FFFFFF' />
          {generating ? (t('parkingstats.generating')) : (t('parkingstats.report'))}
        </button>
          <br/>
          <br/>


            <LocalizationProvider dateAdapter={AdapterDateFns}>
            <MobileDateTimePicker
                  ampm={false}
                  ampmInClock = {false}
                  value={dateMin}
                  onChange={(newValue) => {
                    setDateMin(newValue);
                    //LoadHistoryData();
                    //console.log(dateMin);
                    //console.log(dateMin.getTime());

                    }}
                  label= {t('parkingstats.begin')}
                  onError={console.log}
                  minDate={new Date('2018-01-01T00:00')}
                  inputFormat="yyyy/MM/dd HH:mm"
                  mask="___/__/__ __:__ _M"
                  renderInput={(params) => <TextField {...params} />}
                />

                <MobileDateTimePicker
                      ampm={false}
                      ampmInClock={false}
                      value={dateMax}
                        onChange={(newValue) => {
                            setDateMax(newValue);
                            //LoadHistoryData();
                            }}
                      label={t('parkingstats.end')}
                      onError={console.log}
                      minDate={new Date('2018-01-01T00:00')}
                      inputFormat="yyyy/MM/dd HH:mm"
                      mask="___/__/__ __:__ _M"
                      renderInput={(params) => <TextField {...params} />}
                    />


           </LocalizationProvider>
           <Button
          onClick={() => {
            LoadHistoryData();
          }}
        >
            {t('charttable.loaddata')}
        </Button>
        <Button
        onClick={() => {
         //LoadDefaultHistoryData();
        }}
        >
            {t('charttable.resetdata')}
        </Button>

        <Accordion>
         <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
          <Typography>{t('parkingstats.main')}</Typography>
          </AccordionSummary>
          <AccordionDetails>
          <TableContainer component={Paper}>
           <Table sx={{ minWidth: 650 }} aria-label="simple table">
             <TableHead>
                <TableRow>
                      <TableCell>{t('parkingstats.howmanycars')}</TableCell>
                      <TableCell>{t('parkingstats.howmanycarsleave')}</TableCell>
                      <TableCell>{t('parkingstats.howmanycarsfinished')}</TableCell>
                      <TableCell>{t('charttable.avgparktime')}</TableCell>
                      <TableCell>% {t('charttable.entries.2')}</TableCell>
                      <TableCell>% {t('charttable.exits.2')}</TableCell>
                      <TableCell>Min {t('charttable.free.2')}</TableCell>
                      <TableCell>Max {t('charttable.free.2')}</TableCell>
                      <TableCell>Min {t('charttable.busy.2')}</TableCell>
                      <TableCell>Max {t('charttable.busy.2')}</TableCell>
               </TableRow>
             </TableHead>
             <TableBody>
                <TableRow>
                <TableCell >{arrayWjazdy.length}</TableCell>
                <TableCell >{arrayZjazdy.length}</TableCell>
                  <TableCell >{arrayZajete.length}</TableCell>
                  <TableCell >{seconds2time(avgZajete)}</TableCell>
                  <TableCell >{percentageWolne}%</TableCell>
                  <TableCell >{percentageZajete}%</TableCell>
                  <TableCell >{seconds2time(minWolne)}</TableCell>
                   <TableCell >{seconds2time(maxWolne)}</TableCell>
                   <TableCell >{seconds2time(minZajete)}</TableCell>
                   <TableCell >{seconds2time(maxZajete)}</TableCell>


                 </TableRow>

             </TableBody>
           </Table>
         </TableContainer>
          </AccordionDetails>
        </Accordion>

        <Accordion>
         <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
          <Typography>{t('parkingstats.allfinishedenters')}</Typography>
          </AccordionSummary>
          <AccordionDetails>
          <TableContainer component={Paper}>
           <Table sx={{ minWidth: 650 }} aria-label="simple table">
             <TableHead>
                <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>{t('charttable.id')}</TableCell>
                 <TableCell>{t('parkingstats.duration')}</TableCell>
                 <TableCell >{t('charttable.description')}</TableCell>
                 <TableCell >Start</TableCell>
                 <TableCell >Stop</TableCell>
               </TableRow>
             </TableHead>
             <TableBody>
               {stats.detectorsDurations.map(item => (
                 <TableRow
                   key={item.id}
                   sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                 >
                  <TableCell >{item.id}</TableCell>
                  <TableCell >{item.address}</TableCell>
                   <TableCell >{seconds2time(item.duration)}</TableCell>
                   <TableCell >{item.type}</TableCell>
                   <TableCell ><Moment format = "HH:mm:ss - DD/MM/YYYY" unix>{item.start}</Moment></TableCell>
                   <TableCell ><Moment format = "HH:mm:ss - DD/MM/YYYY" unix>{item.stop}</Moment></TableCell>

                 </TableRow>
               ))}
             </TableBody>
           </Table>
         </TableContainer>
          </AccordionDetails>
        </Accordion>

        <Accordion>
         <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
          <Typography>{t('parkingstats.allenters')}</Typography>
          </AccordionSummary>
          <AccordionDetails>
          <TableContainer component={Paper}>
           <Table sx={{ minWidth: 650 }} aria-label="simple table">
             <TableHead>
                <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>{t('charttable.id')}</TableCell>
                 <TableCell>{t('charttable.description')}</TableCell>
                 <TableCell>{t('parkingstats.time')}</TableCell>
               </TableRow>
             </TableHead>
             <TableBody>
               {stats.detectorsActions.map(item => (
                 <TableRow
                   key={item.id}
                   sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                 >
                  <TableCell >{item.id}</TableCell>
                  <TableCell >{item.address}</TableCell>
                  <TableCell >{item.type}</TableCell>
                  <TableCell ><Moment format = "HH:mm:ss - DD/MM/YYYY" unix>{item.timestamp}</Moment></TableCell>
                 </TableRow>
               ))}
             </TableBody>
           </Table>
         </TableContainer>
          </AccordionDetails>
        </Accordion>


          <Accordion>
         <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
              <Typography>{t('parkingstats.interval')}</Typography>
          </AccordionSummary>
          <AccordionDetails>
         <BarChart width={width - 40} height={height - 20} data={stats.detectorsDurationsHours} margin={{ top: 5, right: 20, bottom: 5, left: 0 }}>
          <Bar dataKey="entries" name={t('parkingstats.entries')} fill="green" />
          <Bar dataKey="exits" name={t('parkingstats.exits')} fill="red" />

         <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
         <XAxis dataKey="fromTimestamp" />
         <YAxis />

         <Tooltip />
        </BarChart>
          <TableContainer component={Paper}>
           <Table sx={{ minWidth: 650 }} aria-label="simple table">
             <TableHead>
                <TableRow>
                <TableCell>ID</TableCell>

                 <TableCell >{t('parkingstats.howmanye')}</TableCell>
                 <TableCell >{t('parkingstats.howmanyl')}</TableCell>
                 <TableCell >Start</TableCell>
                 <TableCell >Stop</TableCell>
               </TableRow>
             </TableHead>
             <TableBody>
               {stats.detectorsDurationsHours.map(item => (
                 <TableRow
                   key={item.id}
                   sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                 >
                  <TableCell >{item.id}</TableCell>
                  <TableCell >{item.entries}</TableCell>
                  <TableCell >{item.exits}</TableCell>
                  <TableCell >{item.fromTimestamp}</TableCell>
                  <TableCell >{item.toTimestamp}</TableCell>
                 </TableRow>
               ))}
             </TableBody>
           </Table>
         </TableContainer>
          </AccordionDetails>
        </Accordion>


{((params.parkingID <= 3) || (params.parkingID == 5)) && (
        <Accordion>
         <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography>{t('parkingstats.busy15')}</Typography>
          </AccordionSummary>
          <AccordionDetails>
        <LineChart width={width - 40} height={height - 20} data={items} margin={{ top: 5, right: 20, bottom: 5, left: 0 }}>
          <Line type="step" dataKey="occupied" name={t('parkingstats.occupied')} stroke="red" />
          {/*<Line type="step" dataKey="free" stroke="green" />*/}

         <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
         <XAxis dataKey="date" />

         <YAxis />

        <Tooltip />
        </LineChart>
          <TableContainer component={Paper}>
           <Table sx={{ minWidth: 650 }} aria-label="simple table">
             <TableHead>
                <TableRow>
                <TableCell>ID</TableCell>

                        <TableCell >{t('parkingstats.busy')}</TableCell>
                        <TableCell >{t('parkingstats.free')}</TableCell>
                        <TableCell >{t('parkingstats.allspaces')}</TableCell>
                        <TableCell >{t('parkingstats.time')}</TableCell>
               </TableRow>
             </TableHead>
             <TableBody>
               {items.map(item => (
                 <TableRow
                   key={item.id}
                   sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                 >
                  <TableCell >{item.id}</TableCell>

                   <TableCell >{item.occupied}</TableCell>
                   <TableCell >{item.free}</TableCell>
                   <TableCell >{item.max}</TableCell>
                   <TableCell >{item.date}</TableCell>


                 </TableRow>
               ))}
             </TableBody>
           </Table>
         </TableContainer>
          </AccordionDetails>
        </Accordion>)}
          <div id="div2PDF" style={{ display: "none" }} >
          <BarChart width={width - 40} height={height - 20} data={stats.detectorsDurationsHours} margin={{ top: 5, right: 20, bottom: 5, left: 0 }}>
            <Bar dataKey="entries" name={t('parkingstats.entries')} fill="green" />
            <Bar dataKey="exits" name={t('parkingstats.exits')} fill="red" />

            <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
            <XAxis dataKey="fromTimestamp" />
            <YAxis />

            <Tooltip />
          </BarChart>
          {params.parkingID <= 3 && (<p><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /></p>)}
          {params.parkingID <= 3 && ( <LineChart width={width - 40} height={height - 20} data={items} margin={{ top: 5, right: 20, bottom: 5, left: 0 }}>
              <Line type="step" dataKey="occupied" name={t('parkingstats.occupied')} stroke="red" />
              {/*<Line type="step" dataKey="free" stroke="green" />*/}

              <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
              <XAxis dataKey="date" />

              <YAxis />

              <Tooltip  />
            </LineChart>)}
        </div>




        </div>

      )

    }



    if (error) {
      return <div>{t('detectord.error')}{error.message}</div>;
     } else if (!isLoaded) {
      return <div>{t('detectord.loading')}</div>;
     } else {
       return (

        <div>
        {loadStatistics()}
        </div>
       );
     }
   }

export default ParkingStats;

ReactDOM.render(<ParkingStats />, document.getElementById("root"));
